/**
 * ==================================
 * 全局变量：一定要在脚本顶部声明
 * ==================================
 */
let userInput = "";   // 存客户输入的原文（用于产品标题）
let promptForAI = ""; // 翻译后的英文（用于生成图片）
let isGenerating = false; // 是否正在生成图像

document.addEventListener("DOMContentLoaded", function () {
  /**
   * ===============================
   *  1. 基础 DOM 获取 & 文本框自适应
   * ===============================
   */
  const chatInput = document.getElementById("chat-input");
  const sendButton = document.getElementById("send-button");
  const responseBox = document.getElementById("chat-response");
  const addToBagBtn = document.getElementById("addToBagBtn");
  const sendIcon = document.getElementById("send-icon");
  const typingPlaceholder = document.getElementById("typing-placeholder");

  // Textarea 自适应处理
  const maxHeight = 245; 
  const initialHeight = chatInput.offsetHeight; 
  chatInput.addEventListener("input", function () {
    this.style.height = "auto"; 
    const newHeight = Math.min(this.scrollHeight, maxHeight);
    this.style.height = Math.max(newHeight, initialHeight) + "px";
    this.style.overflowY = (this.scrollHeight > maxHeight) ? "auto" : "hidden";
  });

  chatInput.addEventListener("focus", function () {
    typingPlaceholder.style.display = "none";
  });
  chatInput.addEventListener("blur", function () {
    if (chatInput.value === "") {
      typingPlaceholder.style.display = "inline";
      typeEffect();
    }
  });
  chatInput.addEventListener("input", function () {
    sendIcon.style.transform = chatInput.value.trim() ? "rotate(90deg)" : "rotate(0deg)";
  });

  /**
   * ===============================
   *  2. 多语言提示配置
   * ===============================
   */
  let messages = {
    en: [
      "Describe the jewellery you're dreaming of...",
      "A star signet ring with ruby...",
      "A heart necklace studded with diamonds... "
    ],
    zh: [
      "描述您梦想中的珠宝...",
      "一枚镶嵌红宝石的星座印章戒指...",
      "一条镶满钻石的心型项链..."
    ]
  };

  let errorMessages = {
    en: {
      empty: "Please write a description of your dream jewellery.",
      error: "Error fetching response. Please try again.",
      uploadFail: "Failed to create product. Please try again later.",
      uploadSuccess: "Product created successfully. Redirecting...",
      generating: "Generating image..."
    },
    zh: {
      empty: "请输入一段您梦想珠宝的描述。",
      error: "请求错误，请重试。",
      uploadFail: "创建产品失败，请稍后再试。",
      uploadSuccess: "产品已成功创建，正在跳转...",
      generating: "正在生成图像..."
    }
  };

  /**
   * ===============================
   *  3. 显示提示信息（不会挡住图片）
   * ===============================
   */
  function showStatusMessage(text, isSuccess = false) {
    const statusBox = document.getElementById("statusMessage");
    if (!statusBox) return;
    
    statusBox.textContent = text;
    statusBox.style.color = isSuccess ? "#716F6E" : "#000000";
    statusBox.style.fontWeight = "400";
    statusBox.style.transition = "opacity 0.3s ease";
    statusBox.style.display = "block";
    statusBox.style.opacity = 1;
    
    setTimeout(() => {
      statusBox.style.opacity = 0;
      setTimeout(() => {
        statusBox.style.display = "none";
      }, 300);
    }, 3000);
  }

  /**
   * ===============================
   *  4. 语言 & 货币检测 + 打字机效果
   * ===============================
   */
  function detectShopifyLanguage() {
    return document.documentElement.lang || (window.Shopify && window.Shopify.locale) || "en";
  }

  function detectShopifyCurrency() {
    return window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "USD";
  }

  let currentLang = detectShopifyLanguage();
  let speed = currentLang === "zh" ? 300 : 100;
  let deleteSpeed = 50;
  let pauseTime = 1500;
  let textIndex = 0;
  let index = 0;
  let isDeleting = false;
  
  function typeEffect() {
    let currentTextArray = messages[currentLang] || messages["en"];
    let currentText = currentTextArray[textIndex];

    if (!isDeleting) {
      typingPlaceholder.innerHTML = currentText.substring(0, index);
      index++;
      if (index > currentText.length) {
        setTimeout(() => {
          isDeleting = true;
          typeEffect();
        }, pauseTime);
        return;
      }
    } else {
      typingPlaceholder.innerHTML = currentText.substring(0, index);
      index--;
      if (index === 0) {
        isDeleting = false;
        textIndex = (textIndex + 1) % currentTextArray.length;
      }
    }
    setTimeout(typeEffect, isDeleting ? deleteSpeed : speed);
  }
  typeEffect();

  function updateLanguageBasedOnCurrency() {
    let currency = detectShopifyCurrency();
    let newLang = currency === "CNY" ? "zh" : "en";
    if (newLang !== currentLang) {
      currentLang = newLang;
      textIndex = 0;
      index = 0;
      isDeleting = false;
      typingPlaceholder.innerHTML = "";
      speed = currentLang === "zh" ? 300 : 100;
      typeEffect();
    }
  }
  updateLanguageBasedOnCurrency();
  setInterval(updateLanguageBasedOnCurrency, 2000);

  /**
   * ===============================
   *  5. “Send” 按钮（调用翻译 + AI Worker生成图像）
   * ===============================
   */
  function isEnglish(text) {
    return !/[^\x00-\x7F]/.test(text);
  }

  sendButton.addEventListener("click", async function () {
    const statusBox = document.getElementById("statusMessage");
    if (statusBox) {
      statusBox.textContent = "";
      statusBox.style.opacity = 0;
    }

    if (isGenerating) {
      console.log("Already generating image...");
      return;
    }

    // 保存客户原始输入，用作产品标题
    userInput = chatInput.value.trim();
    if (!userInput) {
      responseBox.innerHTML = `<p style='color:red;'>${errorMessages[currentLang].empty}</p>`;
      return;
    }

    isGenerating = true;
    sendButton.disabled = true;
    responseBox.innerHTML = `<p><span class='generating-text'>${errorMessages[currentLang].generating}</span></p>`;

    // 使用翻译后的文本作为 AI 图片生成的 prompt
    let finalPrompt = "";
    if (isEnglish(userInput)) {
      finalPrompt = userInput;
    } else {
      try {
        let translationRes = await fetch("https://fragrant-block-f9fd.cold-fire-c13d.workers.dev/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            text: userInput,
            targetLanguage: "en"
          })
        });
        if (!translationRes.ok) {
          const errText = await translationRes.text();
          console.error("Translation Worker Error:", translationRes.status, errText);
          responseBox.innerHTML = `<p style='color:red;'>${errorMessages[currentLang].error}</p>`;
          return;
        }
        let translationData = await translationRes.json();
        finalPrompt = translationData.data.translations[0].translatedText;
      } catch (error) {
        console.error("Translation error:", error);
        responseBox.innerHTML = `<p style='color:red;'>${errorMessages[currentLang].error}</p>`;
        return;
      }
    }
    promptForAI = finalPrompt; // 用于生成图像的英文 prompt

    try {
      let aiResponse = await fetch("https://autumn-recipe-ba03.cold-fire-c13d.workers.dev/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ prompt: promptForAI, output_format: "webp" })
      });

      if (!aiResponse.ok) {
        const errorText = await aiResponse.text();
        console.error("AI Worker Error:", aiResponse.status, errorText);
        responseBox.innerHTML = `<p style='color:red;'>${errorMessages[currentLang].error}</p>`;
        return;
      }

      let aiData = await aiResponse.json();
      if (aiData && aiData.image) {
        let imageUrl = "data:image/webp;base64," + aiData.image;
        responseBox.innerHTML = `<img id="generatedImage" src="${imageUrl}" alt="Generated Jewellery Image" style="max-width:100%;">`;
        const generatedImage = document.getElementById("generatedImage");
        function showAddToBagButton() {
          void addToBagBtn.offsetWidth;
          addToBagBtn.classList.add("generated");
        }
        if (generatedImage.complete) {
          showAddToBagButton();
        } else {
          generatedImage.addEventListener("load", showAddToBagButton);
        }
      } else {
        console.error("Invalid AI Response", aiData);
        responseBox.innerHTML = `<p style='color:red;'>${errorMessages[currentLang].error}</p>`;
      }
    } catch (error) {
      console.error("Error calling AI Worker:", error);
      responseBox.innerHTML = `<p style='color:red;'>${errorMessages[currentLang].error}</p>`;
    } finally {
      isGenerating = false;
      sendButton.disabled = false;
    }
  });

  /**
   * ===============================
   *  6. “Add to Bag” 按钮（上传到 Shopify）
   * ===============================
   */
  addToBagBtn.addEventListener("click", async () => {
    const imageElement = document.getElementById("generatedImage");
    if (!imageElement) {
      showStatusMessage(errorMessages[currentLang].error);
      return;
    }

    const imageSrc = imageElement.src;
    const base64Part = imageSrc.split(",")[1];
    // 使用客户原始输入作为产品标题
    const title = userInput.trim();
    if (!title || !base64Part) {
      showStatusMessage(errorMessages[currentLang].empty);
      return;
    }

    const currentCurrency = detectShopifyCurrency();
    addToBagBtn.disabled = true;
    addToBagBtn.textContent = currentLang === "zh" ? "上传中..." : "Uploading...";

    try {
      // 前端主动将当前币种信息传递给 Worker
      const res = await fetch("https://young-wave-9a5a.cold-fire-c13d.workers.dev/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title: title,  // 使用原始文本
          imageBase64: "data:image/webp;base64," + base64Part,
          currency: currentCurrency
        })
      });

      const data = await res.json();
      if (data.success) {
        showStatusMessage(errorMessages[currentLang].uploadSuccess, true);
        setTimeout(() => {
          window.location.href = data.productUrl;
        }, 1000);
      } else {
        console.error("Shopify Worker Error:", data.error);
        showStatusMessage(errorMessages[currentLang].uploadFail);
      }
    } catch (err) {
      console.error("请求失败:", err);
      showStatusMessage(errorMessages[currentLang].uploadFail);
    } finally {
      addToBagBtn.disabled = false;
      addToBagBtn.textContent = "Add to Bag";
    }
  });

  /**
   * ===============================
   *  7. 监听“Generate” 按钮显示区
   * ===============================
   */
  document.querySelector(".chat-button").addEventListener("click", function(){
    const chatBox = document.getElementById("chat-response");
    void chatBox.offsetWidth;
    chatBox.classList.add("generated");
    addToBagBtn.classList.remove("generated");
  });
});
